import React from "react";
import type { SolutionFeedbackFieldProps } from "../../../../../../../../types/feedback/feedback";
import CustomSelect from "../../../../../../../common/custom-select";

const NextStepField: React.FC<SolutionFeedbackFieldProps> = ({ formState, setFormState }) => {
  if (formState.impactResponse !== "yes" && formState.impactResponse !== "somewhat") return null;
  return (
  <div>
    <label className="block text-[16px] font-medium text-brand-textSubheading mb-[24px]">
      If this looked like a good fit, what would be your likely next step internally?
    </label>
    <CustomSelect
      options={[
        { label: "I'd share it with my manager / team lead", value: "share_manager" },
        { label: "I'd bring it to a director / VP", value: "bring_director" },
        { label: "I'd try to pilot it with a small group", value: "pilot_small_group" },
        { label: "I'd bookmark it for later", value: "bookmark_later" },
        { label: "Not sure / I wouldn't take action right now", value: "no_action" },
      ]}
      selectedValue={formState.nextStep ?? ""}
      onChange={(value) => setFormState((prev) => ({ ...prev, nextStep: value }))}
      placeholder="Select your likely next step..."
    />
  </div>
  );
};

export default NextStepField;
